import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http_auth} from "@utils"
import {toast} from "react-toastify"
import {REFRESH_TOKEN} from "../../../utility/Utils"
import * as auth from "../Auth"

export const getReportsList = createAsyncThunk('report/getReportsList', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/admin/v1/report/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const getReportParamsById = createAsyncThunk('report/getReportParamsById', async (dataId, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post(`/admin/v1/report/param/list/${dataId}`, {})
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const reportsSlice = createSlice({
    name: 'reports',
    initialState: {
        reports: [],
        reportParams: [],

        count_item: 0,
        total_count: 0,
        current_page: 0,
        isLoading: false
    },
    reducers: {},
    extraReducers: {
        [getReportsList.fulfilled]: (state, actions) => {
            state.reports = actions.payload?.data
            state.count_item = actions.payload?.count
            state.total_count = actions.payload?.total_count
            state.current_page = actions.payload?.page
            state.isLoading = false
        },
        [getReportsList.pending]: (state) => {
            state.isLoading = true
        },
        [getReportsList.rejected]: (state, action) => {
            toast.error(action.payload)
            state.isLoading = false
        },

        [getReportParamsById.fulfilled]: (state, actions) => {
            state.reportParams = actions.payload?.data
            state.count_item = actions.payload?.count
            state.total_count = actions.payload?.total_count
            state.current_page = actions.payload?.page
            state.isLoading = false
        },
        [getReportParamsById.pending]: (state) => {
            state.isLoading = true
        },
        [getReportParamsById.rejected]: (state) => {
            toast.error("Error")
            state.isLoading = false
        }
    }
})

export const {} = reportsSlice.actions
export default reportsSlice.reducer
